"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FormComponent = /*#__PURE__*/function () {
  function FormComponent() {
    _classCallCheck(this, FormComponent);

    this.init();
    this.initNetteFormValidation();
    this.imageDimensions = {};
    this.checkImageDimensions(); // AJAX FORM SENT

    var submitCurrentValue = "";
    $.nette.ext("genericFormAjax", {
      before: function before(jqXHR, settings) {
        if (settings.hasOwnProperty("nette")) {
          submitCurrentValue = $(settings.nette.el).val();
          $(settings.nette.el).val("");
          $(settings.nette.el).addClass("sending");
        }
      },
      complete: function complete(jqXHR, status, settings) {
        if (settings.hasOwnProperty("nette")) {
          $(settings.nette.el).val(submitCurrentValue);
          $(settings.nette.el).removeClass("sending");
        }
      }
    });

    var _this = this;

    Nette.validators.AppFormsValidationRules_validateImageDimensions = function (elem, args, file) {
      console.log(elem, args, file);
      var id = $(elem).attr("id");
      var result = true; // CHECK DIMENSIONS

      if (typeof _this.imageDimensions[id] !== "undefined") {
        if (args.width !== _this.imageDimensions[id].width) {
          result = false;
        }

        if (args.height !== _this.imageDimensions[id].height) {
          result = false;
        }
      }

      return result;
    };

    Nette.validators.AppFormsValidationRules_validateFileType = function (elem, args, val) {
      console.log(elem);
      console.log(args);
      console.log(val);
      var file = val[0];
      console.log(file);

      if (file.type !== args) {
        return false;
      }

      return true;
    };
  }

  _createClass(FormComponent, [{
    key: "checkImageDimensions",
    value: function checkImageDimensions() {
      var _this = this;

      $(document).on("change", ".checkImageDimensions", function () {
        var id = $(this).attr("id");
        var img = new Image();
        var file = this.files[0];
        img.src = window.URL.createObjectURL(file);

        img.onload = function () {
          _this.imageDimensions[id] = {
            width: img.width,
            height: img.height
          };
        };
      });
    }
    /**
     * Nette Form Validation
     */

  }, {
    key: "initNetteFormValidation",
    value: function initNetteFormValidation() {
      Nette.showFormErrors = function (form, errors) {
        var validationType = $(form).attr("data-validationtype"); // REMOVE ALL ERRORS FROM FORM

        $(".wrapper-form-input", form).removeClass("error");
        $(".error-text", form).remove();

        switch (validationType) {
          case "fields":
            errors.forEach(function (error) {
              var field = $(error.element, form);
              var wrapper = field.parents(".wrapper-form-input");
              wrapper.addClass("error"); // SET STYLE AS INVALID FIELD
              // ADD ERROR MESSAGE TO FIELD

              wrapper.prepend("<div class='error-text'>" + error.message + "</div>");
            });
        }
      };
    }
  }, {
    key: "init",
    value: function init() {}
  }]);

  return FormComponent;
}();